import useSWR from "swr";
import { fetcher } from "../fetcher";
import { useMainDict } from "./useTranslation";

export type CarouselImageType = {
  id: number;
  attributes: {
    altText: string;
    order: number;
    image: {
      data: {
        id: number;
        attributes: {
          url: string;
          width: number;
          height: number;
          alternativeText: string | null;
        };
      };
    };
  };
};

type CarouselImagesResponseType = {
  data: CarouselImageType[];
  meta: {
    pagination: {
      total: number;
    };
  };
};

const getApiRoute = (language: string) =>
  `/carousel-images?locale=${language}&populate=image&sort=order:asc`;

export async function preFetchCarouselImages(language: string) {
  const apiRoute = getApiRoute(language);
  const data = await fetcher<CarouselImagesResponseType>(apiRoute);
  return { [apiRoute]: data };
}

export function useCarouselImages() {
  const { language } = useMainDict();
  const { data, error, isLoading } = useSWR<CarouselImagesResponseType>(
    getApiRoute(language),
    fetcher
  );

  const images =
    data?.data?.sort((a, b) => a.attributes.order - b.attributes.order) || [];

  return {
    images,
    isLoading,
    isError: error,
  };
}
